var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/get-threads.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { deserialise } from "kitsu-core";

// src/constants/messaging-requests.constants.ts
var MESSAGING_THREADS_PATH = "/v1/messaging-threads";
var MESSAGING_THREADS_PATH_V2 = "/v2/messaging-threads";
var GET_MESSAGING_CONTACTS_PATH = "/v1/messaging-contacts";
var THREAD_MESSAGES_PATH = "/v1/thread-messages";
var MESSAGING_CONFIG_PATH = "/v1/messaging-configs";
var GENERATE_QUESTIONNAIRE_PATH = "/v1/generate-questionnaire";
var NEXT_QUESTIONNAIRE_PATH = "/v1/next";

// src/get-threads.ts
var parseV2toV1 = (response) => {
  const threads = response.data.map((thread) => {
    const _a = thread, { lastMessageSentAt, lastMessageText } = _a, rest = __objRest(_a, ["lastMessageSentAt", "lastMessageText"]);
    const parsedThread = __spreadProps(__spreadValues({}, rest), {
      type: "thread",
      latestMessage: {
        data: {
          id: `ID-${lastMessageSentAt}`,
          sentAt: lastMessageSentAt,
          text: lastMessageText,
          type: "message",
          /*
            Adding a generic object as "sender" to respect TS types, but it won't
            be used in the threads. The attr "sender" is required when the message type
            is "document", which won't be the case here.
          */
          sender: {
            data: {
              id: `SENDER-${lastMessageSentAt}`,
              type: "participant"
            }
          }
        }
      }
    });
    return parsedThread;
  });
  return __spreadProps(__spreadValues({}, response), {
    data: threads
  });
};
var getThreads = (_0) => __async(void 0, [_0], function* ({
  numberOfThreads,
  pageParam,
  enableV2 = false
}) {
  const requestPath = enableV2 ? MESSAGING_THREADS_PATH_V2 : MESSAGING_THREADS_PATH;
  const path = pageParam || `${requestPath}?page[size]=${numberOfThreads}`;
  const response = yield leagueFetch(path);
  if (!response.ok) {
    throw new Error(`getThreads error: ${response.status}`);
  }
  const responseJson = yield response.json();
  const deserializedJson = deserialise(responseJson);
  if (enableV2) {
    return parseV2toV1(deserializedJson);
  }
  return deserializedJson;
});

// src/get-thread-details.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise2 } from "kitsu-core";
var getThreadDetails = (threadId) => __async(void 0, null, function* () {
  const response = yield leagueFetch2(`${MESSAGING_THREADS_PATH}/${threadId}`);
  if (!response.ok) {
    throw new Error(`getThreadDetails error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise2(responseJson);
});

// src/get-messaging-contacts.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise3 } from "kitsu-core";
var getMessagingContacts = () => __async(void 0, null, function* () {
  const response = yield leagueFetch3(`${GET_MESSAGING_CONTACTS_PATH}`);
  if (!response.ok) {
    throw new Error(`getMessagingContacts error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise3(responseJson);
});

// src/get-messages-for-thread.ts
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise4 } from "kitsu-core";
var getMessagesForThread = (threadId, requestPath) => __async(void 0, null, function* () {
  const path = requestPath || `${THREAD_MESSAGES_PATH}/${threadId}?page[size]=30`;
  const response = yield leagueFetch4(path);
  if (!response.ok) {
    throw new Error(`getMessagesForThread error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise4(responseJson);
});

// src/patch-thread-is-read.ts
import { leagueFetch as leagueFetch5 } from "@leagueplatform/league-fetch";
var patchThreadIsRead = (threadId) => __async(void 0, null, function* () {
  const response = yield leagueFetch5(`${MESSAGING_THREADS_PATH}/${threadId}`, {
    method: "PATCH",
    body: JSON.stringify({
      data: {
        id: threadId,
        type: "thread",
        attributes: {
          isRead: true
        }
      }
    })
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while patching!");
});

// src/post-messaging-thread.ts
import { leagueFetch as leagueFetch6 } from "@leagueplatform/league-fetch";
var getThreadFormDataValue = (newThreadData, isQuestionnaireDisabled) => {
  const threadFormData = new FormData();
  const { subject = "", participants, text, document, answers } = newThreadData;
  const formattedThreadData = isQuestionnaireDisabled ? JSON.stringify({
    data: {
      type: "thread",
      attributes: __spreadValues({
        subject
      }, text && { messageText: text }),
      relationships: {
        participants: {
          data: participants
        }
      }
    }
  }) : JSON.stringify({
    data: {
      type: "thread",
      attributes: __spreadProps(__spreadValues({}, text && { messageText: text }), {
        answers
      })
    }
  });
  threadFormData.append("data", formattedThreadData);
  if (document) {
    threadFormData.append("document", document);
  }
  return threadFormData;
};
var postMessagingThread = (_0) => __async(void 0, [_0], function* ({
  newThreadData,
  isQuestionnaireDisabled
}) {
  const requestPath = isQuestionnaireDisabled ? MESSAGING_THREADS_PATH : MESSAGING_THREADS_PATH_V2;
  const threadFormData = getThreadFormDataValue(
    newThreadData,
    isQuestionnaireDisabled
  );
  const response = yield leagueFetch6(requestPath, {
    method: "POST",
    body: threadFormData
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error("Something went wrong while posting a new thread!");
});

// src/post-create-message-in-thread.ts
import { leagueFetch as leagueFetch7 } from "@leagueplatform/league-fetch";
var getMessageFormDataValue = (newMessageData) => {
  const messageFormData = new FormData();
  const { text = "", document } = newMessageData;
  const formattedMessageData = JSON.stringify({
    data: {
      type: "message",
      attributes: {
        text
      }
    }
  });
  messageFormData.append("data", formattedMessageData);
  if (document) {
    messageFormData.append("document", document);
  }
  return messageFormData;
};
var postCreateMessageInThread = (newMessageData, threadId) => __async(void 0, null, function* () {
  const messageFormData = getMessageFormDataValue(newMessageData);
  const response = yield leagueFetch7(`${THREAD_MESSAGES_PATH}/${threadId}`, {
    method: "POST",
    body: messageFormData
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error(
    "Something went wrong while posting a new message to thread!"
  );
});

// src/get-authenticated-document.ts
import { Auth } from "@leagueplatform/auth";
import { captureError } from "@leagueplatform/observability";
var getAuthenticatedDocument = (downloadURL) => __async(void 0, null, function* () {
  try {
    const token = yield Auth.getToken();
    const response = yield fetch(downloadURL, {
      headers: new Headers({
        Authorization: `Bearer ${token}`
      })
    });
    if (!response.ok) {
      const body = yield response.clone().json();
      captureError(new Error("API getAuthenticatedDocument: call failed"), {
        errorName: "Network Fetch Error",
        tags: { requestUrl: response.url },
        context: {
          Errors: __spreadValues({}, body.errors),
          Response: {
            ok: response.ok,
            redirected: response.redirected,
            status: response.status,
            type: response.type,
            url: response.url,
            method: "GET",
            body: JSON.stringify(body)
          }
        }
      });
      return { error: response, data: null };
    }
    return { error: null, data: response };
  } catch (error) {
    return { error, data: null };
  }
});

// src/get-messaging-config.ts
import { leagueFetch as leagueFetch8 } from "@leagueplatform/league-fetch";
import { captureError as captureError2 } from "@leagueplatform/observability";
import { deserialise as deserialise5 } from "kitsu-core";
var getMessagingConfig = () => __async(void 0, null, function* () {
  var _a;
  const response = yield leagueFetch8(`${MESSAGING_CONFIG_PATH}`);
  if (!response.ok) {
    throw new Error(`get messaging config error: ${response.status}`);
  }
  if (response.ok) {
    const clonedResponse = yield response.clone().json();
    if (!((_a = clonedResponse.data) == null ? void 0 : _a.length)) {
      captureError2(
        new Error(
          "API get messaging config error: missing configuration or bad data"
        ),
        {
          tags: { requestUrl: response.url },
          context: {
            "Response Info": {
              response: JSON.stringify(clonedResponse)
            }
          }
        }
      );
    }
  }
  return deserialise5(response.json());
});

// src/post-generate-questionnaire.ts
import { leagueFetch as leagueFetch9 } from "@leagueplatform/league-fetch";
var postGenerateQuestionnaire = (_0) => __async(void 0, [_0], function* ({
  questionnaireId,
  answers = []
}) {
  const response = yield leagueFetch9(GENERATE_QUESTIONNAIRE_PATH, {
    method: "POST",
    body: JSON.stringify({
      data: {
        type: "questionnaire",
        attributes: {
          nodeId: questionnaireId,
          answers
        }
      }
    })
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error(`postGenerateQuestionnaire error: ${response.status}`);
});

// src/post-questionnaire-next-node.ts
import { leagueFetch as leagueFetch10 } from "@leagueplatform/league-fetch";
var postQuestionnaireNextNode = (nextNode) => __async(void 0, null, function* () {
  const response = yield leagueFetch10(`${NEXT_QUESTIONNAIRE_PATH}`, {
    method: "POST",
    body: JSON.stringify({
      data: {
        type: "next-request",
        attributes: {
          nodeId: nextNode
        }
      }
    })
  });
  if (!response.ok) {
    throw new Error(`postQuestionnaireNextNode error: ${response.status}`);
  }
  return response.json();
});
export {
  GENERATE_QUESTIONNAIRE_PATH,
  GET_MESSAGING_CONTACTS_PATH,
  MESSAGING_CONFIG_PATH,
  MESSAGING_THREADS_PATH,
  MESSAGING_THREADS_PATH_V2,
  NEXT_QUESTIONNAIRE_PATH,
  THREAD_MESSAGES_PATH,
  getAuthenticatedDocument,
  getMessagesForThread,
  getMessagingConfig,
  getMessagingContacts,
  getThreadDetails,
  getThreads,
  patchThreadIsRead,
  postCreateMessageInThread,
  postGenerateQuestionnaire,
  postMessagingThread,
  postQuestionnaireNextNode
};
//# sourceMappingURL=index.js.map